import { AttachmentPolicyInfo, getAttachmentPolicyInfo } from 'owa-attachment-policy';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';
import { lazyGetSharingInformation } from 'owa-sharing-data';
import {
    AttachmentModel,
    lazyCreateAttachmentInfo,
    refreshSharingTipsForAttachment,
    lazySetAttachmentInfo,
} from 'owa-attachment-model-store';

export async function getAttachmentSharingInformation(attachmentModel: AttachmentModel) {
    const getSharingInformation = await lazyGetSharingInformation.import();
    getSharingInformation((<ReferenceAttachment>attachmentModel.model).AttachLongPathName).then(
        async response => {
            if (response && response.ResultCode === AttachmentResultCode.Success) {
                return;
            }

            // TODO: VSO 33448, see if we should be calling initializeAttachment here instead of just setting the
            // attachment info.
            const attachmentPolicyInfo: AttachmentPolicyInfo = getAttachmentPolicyInfo(
                attachmentModel.model,
                true /* isWacPreviewSupportedOnPlatform */
            );

            const info = await lazyCreateAttachmentInfo.importAndExecute(
                attachmentPolicyInfo,
                attachmentModel.attachmentClass,
                attachmentModel.model,
                true /* isCloudy */,
                (<ReferenceAttachment>attachmentModel.model).ProviderType,
                response
            );
            lazySetAttachmentInfo.importAndExecute(attachmentModel.id, info);
            refreshSharingTipsForAttachment(attachmentModel.id);
        }
    );
}
